import { ThemesColors, THEME_CLASSNAME_SUFFIX } from "themes/theme";
import { createGlobalStyle } from "styled-components";

import { commonColors, themesColors } from "themes/colorVariables";

const buildCssVariables = (colors) => {
  let variables = "";
  Object.keys(colors).forEach((key) => {
    variables += `--${key}: ${colors[key]};`;
  });
  return variables;
};

const buildThemesCss = (colors: ThemesColors) => {
  let themesClasses = "";
  Object.keys(colors).forEach((themeName) => {
    themesClasses += `
      &.${themeName}${THEME_CLASSNAME_SUFFIX} {
        ${buildCssVariables(colors[themeName])}
      }
    `;
  });
  return themesClasses;
};

export const GlobalStyles = createGlobalStyle`
body {
  ${buildCssVariables(commonColors)}
  ${buildThemesCss(themesColors)}
}
`;
